const ROOT_DOMAIN = process.env.REACT_APP_ROOT_DOMAIN || "";

function normalizeHost(host) {
  if (!host || typeof host !== "string") return "";
  return host.split(",")[0].trim().toLowerCase().split(":")[0];
}

function getHostParts(host) {
  const normalized = normalizeHost(host);
  return normalized ? normalized.split(".") : [];
}

export function getRootDomain(host) {
  const normalized = normalizeHost(host);
  if (!normalized) return "";

  if (ROOT_DOMAIN) {
    return ROOT_DOMAIN.toLowerCase();
  }

  const parts = normalized.split(".");
  if (parts.length <= 2) {
    return normalized;
  }

  return parts.slice(-2).join(".");
}

export function getSubdomainPrefix(host) {
  const normalized = normalizeHost(host);
  if (!normalized) return null;

  const rootDomain = getRootDomain(host);
  if (!rootDomain || normalized === rootDomain || normalized === `www.${rootDomain}`) {
    return null;
  }

  const hostParts = normalized.split(".");
  const rootParts = rootDomain.split(".");
  if (hostParts.length !== rootParts.length + 1) {
    return null;
  }

  const candidateRoot = hostParts.slice(-rootParts.length).join(".");
  if (candidateRoot !== rootDomain) {
    return null;
  }

  return hostParts[0];
}

export function isRootDomain(host) {
  const normalized = normalizeHost(host);
  const rootDomain = getRootDomain(host);
  return (
    normalized === rootDomain ||
    normalized === `www.${rootDomain}` ||
    normalized === "localhost"
  );
}

export function buildTenantLoginUrl(prefix, host) {
  const rootDomain = getRootDomain(host);
  if (!prefix || !rootDomain) return null;
  const normalizedPrefix = prefix.trim().toLowerCase();
  if (!normalizedPrefix) return null;
  const protocol = window?.location?.protocol || "https:";
  return `${protocol}//${normalizedPrefix}.${rootDomain}${window.location.pathname}`;
}
